import classNames from "classnames";
import React, { useCallback } from "react";

import styles from "./style.module.css";

const ModalButtonTertiary = ({ children, className, disabled, onClick, dataTestId }) => {
  const onButtonClick = useCallback(() => {
    try {
      if (onClick) {
        onClick();
      }
    } catch (error) {
      console.error(error);
    }
  }, [onClick]);

  return (
    <button
      className={classNames(styles.container, className)}
      data-testid={dataTestId}
      onClick={onButtonClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default ModalButtonTertiary;
